module.exports = __webpack_public_path__ + "static/media/OpenSeas_web_1.123c6dfe.jpg";